<template>
  <div class="m2m-bg">
    <b-row>
      <!-- <b-col md="12">
        <header>
          <nav-bar />
        </header>
      </b-col> -->
      <b-col md="12">
        <slide-y-up-transition mode="out-in" origin="center top">
          <router-view />
        </slide-y-up-transition>
      </b-col>
      <!-- <b-col md="12">
        <div class="container">
          <footer class="footer bg-transparent">
            <hr />
            <div class="row align-items-center justify-content-md-between">
              <div class="col-md-6">
                <div>
                  Copyright &copy; {{ year }}
                  <a
                    href="https://www.mouth2mouth-app.com/"
                    target="_blank"
                    rel="noopener"
                  >
                    M2M /
                  </a>
                  <a
                    href="https://www.nextstation.cl"
                    target="_blank"
                    rel="noopener"
                  >
                    Nextstation
                  </a>
                </div>
              </div>
              <div class="col-md-6">
                <ul class="nav nav-footer justify-content-end">
                  <li class="nav-item">
                    <b-link
                      @click="$router.push({ name: 'terms-of-service' })"
                      target="_blank"
                    >
                      {{ $t("term") }} & {{ $t("condition") }}</b-link
                    >
                  </li>
                </ul>
              </div>
            </div>
          </footer>
        </div>
      </b-col> -->
    </b-row>
  </div>
</template>
<script>
import _ from "lodash";
import { SlideYUpTransition } from "vue2-transitions";
import NavBar from "@/components/Ecommerce/navbar.vue";

import { mapGetters, mapActions } from "vuex";
export default {
  components: {
    SlideYUpTransition,
    NavBar,
  },
  async created() {
    const data = await this.getCategory();
    this.categories = data.data;
  },
  watch: {
    async productValue() {
      if (this.productValue === "") {
        await this.getProduct({
          currentPage: this.currentPage,
          perPage: this.perPage,
          country: localStorage.getItem("country"),
        });
      }
    },
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      year: new Date().getFullYear(),

      selectData: null,
      categories: null,
      selected: null,
      active: 1,
      sliding: null,
      options: ["products"],
      categories: false,
      productState: true,
      productValue: null,
      companyState: false,
      companyValue: null,
    };
  },
  methods: {
    ...mapActions({
      getCountryCompany: "home/getCountryCompany",
      getProduct: "product/get",
      getCategory: "category/getSelects",
    }),
    async runSearch() {
      await this.getProduct({
        currentPage: this.currentPage,
        perPage: this.perPage,
        country: localStorage.getItem("country"),
        search: this.productValue ? this.productValue : null,
        categories: this.value ? this.value : null,
      });
    },
  },
};
</script>
<style>
</style>